import React from "react";

const Home = () => {
  return (
    <div className="home-container">
      <section className="hero">
        {/*<img src="/images/lucy_logo_short_white.png" alt="Lucy Logo" className="lucy-logo"/>*/}
        <img src="/images/glucy_white.png" alt="Lucy Logo" className="lucy-logo"/>
        {/*<h1>Welcome to Adventure with Lucy</h1>*/}
        {/*<p>Explore the world through sailing, RVing, and off-road adventures!</p>*/}
      </section>

      <section className="intro">
        <h1>Welcome to Adventure with Lucy</h1>
        <p>Explore the world through sailing, RVing, and off-road adventures!</p>
        {/*<h2>Join Us on Our Journey</h2>*/}
        {/*<p>From the open sea to winding mountain trails, follow our travels and learn along the way.</p>*/}
      </section>

      <style>{`
        .home-container {
          text-align: center;
          padding: 50px 20px;
        }
        .hero {
          background: url('/images/lucy_slip.jpeg') center/cover no-repeat;
          padding: 40px 20px;
          // color: white;
          // text-shadow: 2px 2px 10px rgba(0, 0, 0, 0.7);
        }
        .lucy-logo {
          width: 600px;
          max-width: 80%;
          margin-bottom: 20px;
          filter: drop-shadow(2px 2px 4px rgba(0, 0, 0, 0.6));
        }
        .intro {
          margin-top: 40px;
          padding: 20px;
        }
      `}</style>
    </div>
  );
};

export default Home;